module.exports = require('./helpers/bundle-url').getBundleURL('6ZzK6') + "../../resources/images/" + require('./helpers/bundle-manifest').resolve("e1Ant");